import { render, staticRenderFns } from "./EditHyperlinksTable.vue?vue&type=template&id=0a1577c0&scoped=true"
import script from "./EditHyperlinksTable.ts?vue&type=script&lang=ts&external"
export * from "./EditHyperlinksTable.ts?vue&type=script&lang=ts&external"
import style0 from "./EditHyperlinksTable.vue?vue&type=style&index=0&id=0a1577c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1577c0",
  null
  
)

export default component.exports